module.exports = __webpack_public_path__ + "img/verydissatisfied_gray.0ae2ce25.png";